// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-avatar[data-v-53a3d001]{width:42px;height:42px;border-radius:50%;overflow:hidden;-o-object-fit:cover;object-fit:cover;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-right:12px;background-color:#e8edff;line-height:1.5;letter-spacing:.2px;font-size:18px}", ""]);
// Exports
module.exports = exports;
